import { z } from 'zod';
import { mediaIdSchema, mediaTypeSchema, type MediaType } from './content';

export type DownloadStatus = 'queued' | 'downloading' | 'paused' | 'done' | 'error';

export interface DownloadItem {
  id: string;
  mediaId: string;
  contentType: MediaType;
  season: number | null;
  episode: number | null;
  title: string;
  episodeTitle: string | null;
  year: number | null;
  posterUrl: string | null;
  streamTitle: string;
  size: number | null;
  received: number;
  speed: number;
  status: DownloadStatus;
  error: string | null;
  createdAt: string;
}

export interface DownloadsInfo {
  available: boolean;
  folder: string;
  defaultFolder: string;
  usedBytes: number;
}

export const startDownloadSchema = z.object({
  sessionId: z.string().regex(/^[\w-]{10,64}$/),
  mediaId: mediaIdSchema,
  contentType: mediaTypeSchema,
  season: z.number().int().min(0).nullable().default(null),
  episode: z.number().int().min(0).nullable().default(null),
  title: z.string().min(1).max(300),
  episodeTitle: z.string().max(300).nullable().default(null),
  year: z.number().int().nullable().default(null),
  posterUrl: z.string().max(2000).nullable().default(null),
  streamTitle: z.string().max(500).default(''),
});
export type StartDownloadInput = z.input<typeof startDownloadSchema>;
